import { render, staticRenderFns } from "./EditOrderInfo.vue?vue&type=template&id=37d7f432"
import script from "./EditOrderInfo.vue?vue&type=script&lang=js"
export * from "./EditOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./EditOrderInfo.vue?vue&type=style&index=0&id=37d7f432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports